import {useMutation} from '@tanstack/react-query';
import {API, type CreateFeedbackPayload} from '@chekin/api';
import {useIsMounted} from '@chekin/guestapp-ui-kit';

type Props = {
  onError?: (error: Error) => void;
};
function useMutateFeedback({onError}: Props = {}) {
  const isMounted = useIsMounted();

  const {mutate: createFeedbackMutation, mutateAsync: createFeedbackAsyncMutation} =
    useMutation<unknown, Error, CreateFeedbackPayload>({
      mutationFn: payload => API.feedback.createFeedback(payload),
      onError: error => {
        if (!isMounted.current) {
          return;
        }
        onError?.(error);
      },
    });

  return {createFeedbackMutation, createFeedbackAsyncMutation};
}

export {useMutateFeedback};
